var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAudioInput(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Image Icon Medium") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,17 C1.448,17 1,16.553 1,16 L1,8 C1,7.448 1.448,7 2,7 C2.552,7 3,7.448 3,8 L3,16 C3,16.553 2.552,17 2,17 Z M7,14 L7,10 C7,9.448 6.552,9 6,9 C5.448,9 5,9.448 5,10 L5,14 C5,14.553 5.448,15 6,15 C6.552,15 7,14.553 7,14 Z M11,19 L11,5 C11,4.448 10.552,4 10,4 C9.448,4 9,4.448 9,5 L9,19 C9,19.553 9.448,20 10,20 C10.552,20 11,19.553 11,19 Z M15,16 L15,8 C15,7.448 14.553,7 14,7 C13.447,7 13,7.448 13,8 L13,16 C13,16.553 13.447,17 14,17 C14.553,17 15,16.553 15,16 Z M19,22 L19,2 C19,1.448 18.553,1 18,1 C17.447,1 17,1.448 17,2 L17,22 C17,22.553 17.447,23 18,23 C18.553,23 19,22.553 19,22 Z M23,15 L23,9 C23,8.448 22.553,8 22,8 C21.447,8 21,8.448 21,9 L21,15 C21,15.553 21.447,16 22,16 C22.553,16 23,15.553 23,15 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MLP-deliverables",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Widget-Item-/-Horizontal-Item-/-Common-/-Mouse-Copy",
    transform: "translate(-17.000000, -29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left-Fixed",
    transform: "translate(0.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image-Icon-Medium",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "//-Base",
    fillOpacity: 0,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Glyph"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u21B3-icon-tint",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAudioInput);
export default __webpack_public_path__ + "static/media/ic_audio_input.d26d4aa7e482de2759b8b65c7b65f9dd.svg";
export { ForwardRef as ReactComponent };